<template>
<div>
<el-card shadow="never">
    <el-badge is-dot class="item">快速筛选订单:</el-badge>
    <el-badge value="14" class="item">
      <el-button @click="changeIndex(1)" :class="{'selected': selectedIndex ===1}" size="small">退款(待处理)</el-button>
    </el-badge>
    <el-badge value="30" class="item">
      <el-button @click="changeIndex(2)" :class="{'selected': selectedIndex ===2}" size="small">退货(待处理)</el-button>
    </el-badge>
</el-card>
<refund-money v-if="selectedIndex === 1"></refund-money>
  <RefundGoods v-if="selectedIndex === 2"></RefundGoods>
</div>
</template>
<script>
import RefundMoney from "./RefundMoney.vue";
import RefundGoods from "./RefundGoods.vue";
export default {
  name: "Index",
  components:{
    RefundMoney,
    RefundGoods
  },
  data(){
    return {
      selectedIndex: 1,
      formInline: {
        user: '',
        region: ''
      }
    }
  },
  methods: {
    changeIndex(i){
      this.selectedIndex = Number(i);
    },
    onSubmit() {
      console.log('submit!');
    }
  }
}
</script>



<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
/deep/ .selected {
  background-color: #ecf5ff;
  color:#409eff;
}
</style>